import CloseButton from "components/CloseButton/CloseButton";
import DialogAlert from "components/DialogAlert/DialogAlert";

const DialogResourceForm = ({
    show, toggleShow,
    children 
}) => {
    return (
        <DialogAlert
            show={show}
            toggleShow={toggleShow}>
            <CloseButton onClick={() => toggleShow(false)}/>
            {children}
        </DialogAlert>
    );
}

export default DialogResourceForm;